import { Empty, Button } from 'antd';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  description?: ReactNode;
  ctaLabel?: string;
  onCta?: () => void;
}

export function EmptyState({ title, description, ctaLabel, onCta }: Props) {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <>
          <strong>{title}</strong>
          {description && <div style={{ marginTop: 8, color: '#888' }}>{description}</div>}
        </>
      }
    >
      {ctaLabel && onCta && (
        <Button type="primary" onClick={onCta}>
          {ctaLabel}
        </Button>
      )}
    </Empty>
  );
}
